/**
 * Public surface of the jobs center (ALP-67), used by other features (post page reload, bulk actions, Copilot later).
 * Owned by the jobs-center track; signatures are a contract with the moderation track.
 *   <JobProgress jobId compact? />  live progress + controls for one job
 *   announceJob(job)                start toast + tray refresh for a job the user just started (finish toast via SSE)
 */
export { JobProgress } from "./job-progress";
export { announceJob } from "./toasts";
